<template>
<div class="order-page">
  <van-nav-bar ref="nav" @click-left="back" placeholder :fixed="true" title="确认订单">
    <template #left>
      <van-icon size="20px" name="arrow-left" color="#333" /> </template></van-nav-bar>
  <div class="make-order">
    <OrderCard v-for="card of list" :key="card.id" :cardData="card"></OrderCard>
  </div>
  <div class="footer">
    <div class="price" slot="default">
      合计：<span>¥{{ price }}</span>
    </div>
    <div class="btn" slot="button" @click="makeOrder">确认支付</div>
  </div>
</div>
</template>

<script>
import store from "@/store/index.js";
import OrderCard from "@/components/OrderCard";

export default {
  components: {
    OrderCard,
  },
  computed: {
    partalName() {
      return store.state.plat.name;
    },
  },
  data() {
    return {
      goods_sku_id: "",
      list: [],
      price: 0,
      device: "h5",
    };
  },
  async mounted(option) {
    this.goods_sku_id = this.$route.query.goods_sku_id;
    let res = await this.$api({
      url: "/api/goods/preview",
      data: {
        goods_sku_id: this.goods_sku_id,
      },
    });
    if (res.code == 0) {
      console.log(res.data);
      this.list = res.data.course_list;
      this.price = 0;
      for (const iterator of this.list) {
        this.price += iterator.price * 1;
      }
    }
    if (this.$wechat && this.$wechat.isWechat()) {
      this.$wechat.initJssdkShare();
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async makeOrder() {
      var payPrice = Number(this.list[0].price);
      const t = this.$toast.loading('加载中');
      let {
        is_admin,
        mobile
      } = this.$store.state.user;
      let {
        openid
      } = this.$store.state.wx;
      if (mobile == "17600789950" || mobile == "17600789951" || is_admin) {
        payPrice = 0.01;
      }
      let res = await this.$api({
        url: "/api/order/make",
        method: "POST",
        data: {
          platform_id: this.$store.state.partal.flat_id,
          pay_type: 9,
          amount: payPrice,
          goods_sku_id: this.goods_sku_id,
          recharge: 0,
          amount_coin: 0,
          amount_diamond: 0,
          amount_award: 0,
          openid: openid,
        },
      });
      t.clear();
      if (res.code == 0) {
        function onBridgeReady() {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest", {
              appId: "wxb1d573e34d48cbf6",
              timeStamp: res.data.pay.timeStamp + "", //时间戳，自1970年以来的秒数
              nonceStr: res.data.pay.nonceStr, //随机串
              package: res.data.pay.package,
              signType: res.data.pay.signType, //微信签名方式：
              paySign: res.data.pay.paySign, //微信签名◊
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                this.$toast({
                  title: "支付成功",
                  icon: "none",
                });
                setTimeout(() => {
                  this.$store.dispatch("reJump", {
                    path: "/pages/user/purchased",
                    params: "",
                  });
                }, 300);
              }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
        return;
        if (this.$wechat && this.$wechat.isWechat()) {
          this.$wechat.pay(res.data.pay);
        } else {
          this.$toast({
            title: "不是微信环境",
          });
        }
      } else {
        this.$toast(res.msg);
      }
    },
  },
};
</script>

<style scoped>
.make-order {
  padding-top: 26px;
}

.footer {
  width: 750px;
  height: 130px;
  background: #ffffff;
  box-shadow: 0px -1px 5px 0px #ddd9d9;
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: constant(safe-area-inset-bottom);
}

.price {
  font-size: 24px;
  color: #333;
  padding-left: 30px;
}

.price span {
  font-size: 46px;
  color: #ff4d41;
  font-weight: 600;
  letter-spacing: 2px;
}

.btn {
  width: 332px;
  height: 90px;
  background: #a7090a;
  border-radius: 45px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
}
</style>
